import React from "react";
import { useTranslation } from "react-i18next";

/**
 * SectionHeader
 * -------------
 * Shows "PART 1 – Past 3 months" or "PART 2 – These days • Section 3"
 * above the current step, for SGRQ only.
 *
 * Props:
 *  - groupId: string (e.g., "sgrq-part2-s3", "sgrq-part1", "sgrq-preface")
 *  - translationForm: i18next namespace (usually "sgrq")
 */
export default function SectionHeader({ groupId, translationForm = "sgrq" }) {
  const { t } = useTranslation(translationForm);

  if (typeof groupId !== "string" || !groupId.startsWith("sgrq-")) return null;

  // Map group → part/section keys inside the SGRQ namespace
  let partKey = null;
  let sectionKey = null;

  if (groupId === "sgrq-part1") {
    partKey = "sgrq.sections.part1";
  } else if (groupId.startsWith("sgrq-part2")) {
    partKey = "sgrq.sections.part2";
    // extract s1..s7 if present
    const m = groupId.match(/sgrq-part2-(s[1-7])/);
    if (m) sectionKey = `sgrq.sections.${m[1]}`;
  }

  // Preface shows no part/section header by design (paper form)
  if (!partKey && !sectionKey) return null;

  return (
    <div className="space-y-1">
      {partKey && <div className="tracking-wide ">{t(partKey)}</div>}
      {sectionKey && <h3 className="t">{t(sectionKey)}</h3>}
    </div>
  );
}
